<template>
    <!-- 试题范围组件 -->
    <div>
        <el-form-item label="" style="display:inline-block;margin-right:25px" label-width="180px">
            <el-select v-model="gradeIds" placeholder="选择年级，可多选" multiple filterable clearable @change="changeGrade">
                <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label-width="0" style="display:inline-block">
            <el-select v-model="bookIds" placeholder="选择教材，可多选" multiple filterable clearable :disabled="bookDisabled"
                @change="changeBook">
                <el-option v-for="item in bookList" :key="item.value" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
    </div>
</template>

<script>
 import {
        mapState
    } from "vuex";
    export default {
        props: {
            index: {
                type: Number
            },
            info: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        data() {
            return {
                gradeIds: [], //选中的年级id
                bookIds: [], //选中的书籍id
                bookDisabled: true,
                gradeList: [], //请求来的所有年级数据
                bookList: [], //年级对应的书籍数据
                selectGradesList: [], // 被选中的年级信息列表
                selectBooksList: [], // 被选中的书籍信息列表
            }
        },
        computed: {
            ...mapState({
                currentProject: state => state.user.currentProject,
            }),

        },
        methods: {
            // 获取年级列表
            async getStageGrade() {
                let resData = await this.$Api.Activity.getStageGrade();
                // console.log('年级列表', resData)
                this.gradeList = resData.data;
                return new Promise((resolve, reject) => {
                    resolve(resData)
                })
            },
            // 获取年级对应书籍列表
            async getSelectBookList() {
                let data = {
                    gradeIds: this.gradeIds,
                    projectId: this.currentProject.id
                }
                let resData = await this.$Api.Activity.getSelectBookList(data);
                // console.log('书籍列表', resData)
                this.bookList = resData.data;
                return new Promise((resolve, reject) => {
                    resolve(resData)
                })
            },
            // 更改试题范围中的年级
            changeGrade(val) {
                // console.log('选中的年级id', val);
                this.bookDisabled = true;
                let datas = [];
                if (val.length > 0) {
                    this.getSelectBookList();
                    this.bookDisabled = false;
                    this.selectGradesList = [];
                    // console.log('gradeList', this.gradeList);
                    val.map(item => {
                        let res = this.gradeList.find(ele => ele.id == item)
                        this.selectGradesList.push(res);
                    })
                    // console.log('已经选中的年级列表', this.selectGradesList)
                    if (this.selectBooksList.length > 0) {
                        datas = this.operateData()
                        this.$emit('change', {
                            data: datas,
                            index: this.index
                        })

                    }
                    return
                } else {
                    this.bookIds = [];
                    this.selectbooksList = [];
                    this.selectBooksList = [];
                }

            },
            // 更改试题范围中的教材
            changeBook(val) {
                // console.log('选中的书籍id', val);
                this.selectBooksList = [];
                let datas = [];
                if (val.length > 0) {
                    val.map(item => {
                        let res = this.bookList.find(ele => ele.id == item)
                        this.selectBooksList.push(res);
                    })
                    // console.log('已经选中的书籍列表', this.selectBooksList)
                    datas = this.operateData()
                }
                this.$emit('change', {
                    data: datas,
                    index: this.index
                })


            },
            // 选好的年级书籍数据 按规则进行整理
            operateData() {
                let gradeBookInfo = [];
                this.selectGradesList.map(item => {
                    this.selectBooksList.map(ele => {
                        let bookInfo = {
                            bindGradeId: ele.gradeId,
                            gradeId: item.id,
                            bookId: ele.id,
                        }
                        gradeBookInfo.push(bookInfo);
                    })
                })
                // console.log('gradeBookInfo', gradeBookInfo);
                return gradeBookInfo
            }
        },
        mounted() {
            // this.getStageGrade();
            let selectGrade = this.getStageGrade();
            Promise.all([selectGrade]).then((values) => {
                if (values.length > 0 && this.info.length > 0) {
                    let gradeIds = []
                    let bookIds = []
                    this.info.map(item => {
                        if (!(gradeIds.find(ele => ele == item.gradeId))) {
                            gradeIds.push(item.gradeId);
                        }
                        if (!(bookIds.find(ele => ele == item.bookId))) {
                            bookIds.push(item.bookId);
                        }
                    })
                    this.gradeIds = gradeIds;
                    this.changeGrade(gradeIds);
                    let selectBook = this.getSelectBookList();
                    Promise.all([selectBook]).then((values) => {
                        if (values.length > 0) {
                            this.bookDisabled = false;
                            this.changeBook(bookIds);

                        }
                    });
                    this.bookIds = bookIds;
                    // console.log('gradeIds', gradeIds);
                    // console.log('bookIds', bookIds);
                }
            });
        },
    }
</script>

<style>

</style>